export default __webpack_public_path__ + "static/media/p3-19.c11a64fb.png";